import { render, staticRenderFns } from "./Examlist.vue?vue&type=template&id=6c9f122c&scoped=true"
import script from "./Examlist.vue?vue&type=script&lang=js"
export * from "./Examlist.vue?vue&type=script&lang=js"
import style0 from "./Examlist.vue?vue&type=style&index=0&id=6c9f122c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9f122c",
  null
  
)

export default component.exports